import type { IconNode } from '../types';

/**
 * @name unicorn-head
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUuNiA0LjggMi43IDIuMyIgLz4KICA8cGF0aCBkPSJNMTUuNSAxMFMxOSA3IDIyIDJjLTYgMi0xMCA1LTEwIDUiIC8+CiAgPHBhdGggZD0iTTExLjUgMTJIMTEiIC8+CiAgPHBhdGggZD0iTTUgMTVhNCA0IDAgMCAwIDQgNGg3LjhsLjMuM2EzIDMgMCAwIDAgNC00LjQ2TDEyIDdjMC0zLTEtNS0xLTVTOCAzIDggN2MtNCAxLTYgMy02IDMiIC8+CiAgPHBhdGggZD0iTTIgNC41QzQgMyA2IDMgNiAzbDIgNCIgLz4KICA8cGF0aCBkPSJNNi4xNCAxNy44UzQgMTkgMiAyMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/unicorn-head
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const unicornHead: IconNode = [
  ['path', { d: 'm15.6 4.8 2.7 2.3', key: 'q0p4rx' }],
  ['path', { d: 'M15.5 10S19 7 22 2c-6 2-10 5-10 5', key: '1hjyzh' }],
  ['path', { d: 'M11.5 12H11', key: 'dwhguf' }],
  [
    'path',
    {
      d: 'M5 15a4 4 0 0 0 4 4h7.8l.3.3a3 3 0 0 0 4-4.46L12 7c0-3-1-5-1-5S8 3 8 7c-4 1-6 3-6 3',
      key: '571my3',
    },
  ],
  ['path', { d: 'M2 4.5C4 3 6 3 6 3l2 4', key: '1d4svl' }],
  ['path', { d: 'M6.14 17.8S4 19 2 22', key: 'l04gdj' }],
];

export default unicornHead;
